'use client'

import Image from 'next/image'
import styled from 'styled-components'

import { colors } from '@/config/global-parameters'

const Divider = ({
  className,
  isMainPage,
  showMore,
}: {
  className?: string
  showMore: boolean
  isMainPage?: boolean
}) => (
  <>
    <Wrapper className={className}>
      <Image
        alt="triangle"
        height={8}
        src="/icons/triangle.svg"
        width={8}
      />
      <Line />
    </Wrapper>
    {showMore && (
      <>
        <Wrapper>
          <Line />
        </Wrapper>
        {isMainPage && (
          <Wrapper>
            <Line />
          </Wrapper>
        )}
      </>
    )}
  </>
)

const Line = styled.div`
  width: 1px;
  height: calc(100% + 4px);
  transform: translateY(-4px);
  background: ${colors.colorGrey26};
`

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  align-items: center;
`

export default Divider
